// extracted by mini-css-extract-plugin
export var focusVisible = "jfghx71HfEwLTC8LnVnM";
export var icon = "nEmmqQlcs6hf6t05OayQ";
export var inline = "_Je8BKFYmdVw5S1uxpnz";
export var inlineText = "qA04oCosI8FH1R5JjOuv";
export var removePaddingLeft = "dTEru2iMdACh2n4aAqdy";
export var removePaddingRight = "f0FWTpwk6PlOY9CZ1sCh";
export var removeSidePadding = "b3nUEgSlDAJtliU_6qWQ";
export var root = "OqZViNJw5g15kYnJ9yPT";
export var text = "pOhZovNbOT_B19NJEkWj";